import React from 'react';

const FigoSelect = ({
  className,
  controlId,
  custom,
  inputName,
  onChange,
  placeholder,
  renderOptionList,
  title,
  value,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor={controlId}>
      {title}
    </label>

    <select
      className={[custom ? 'custom-select' : 'form-control', className]
        .filter(Boolean)
        .join(' ')}
      id={controlId}
      name={inputName}
      onBlur={onChange}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
    >
      {renderOptionList()}
    </select>
  </div>
);

export default FigoSelect;
